import { createContext, use } from 'react'

export type Theme = 'light' | 'dark' | 'system'
export type ResolvedTheme = 'light' | 'dark'

/** Must stay in sync with the no-flash script in index.html. */
export const THEME_STORAGE_KEY = 'packs-admin-theme'

export interface ThemeContextValue {
    /** The stored preference, which may be `system`. */
    theme: Theme
    /** What is actually on screen right now. Use this for anything that needs a concrete mode. */
    resolvedTheme: ResolvedTheme
    setTheme: (theme: Theme) => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)

export function useTheme(): ThemeContextValue {
    const context = use(ThemeContext)
    if (!context) throw new Error('useTheme must be used within a <ThemeProvider>')
    return context
}
